<template>
  <div class="article-list-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="装修百科" :showBack="true"></my-header>
    <div class="article-tab-part">
      <div v-for="(category) in categoryList" class="top-tab-item" :class="{'tab-selected':category.id == categorySelected}" @click = "selectCategory(category.id)">
        {{category.name}}
      </div>
    </div>
    <mt-loadmore style="font-size:0.24rem;padding-bottom: 0.2rem" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill ='autoFill' bottomLoadingText = '加载更多' ref="loadmore">
      <div v-if="categorySelected != 14" class="cms-article general-box-shadow" v-for="article in articleList" @click="toArticleDetail(article.id,article.title,article.summary)">
        <img class="article-cover" :src="imgUrl+article.cover | ossProcess(690, 320)">
        <div class="article-info">
          <div class="article-title">{{article.title}}</div>
          <div class="article-summary">{{article.summary}}</div>
        </div>
      </div>
      <div v-if="categorySelected == 14" class="cms-article activity-item general-box-shadow" v-for="article in articleList" @click="toArticleDetail(article.id,article.title,article.summary)">
        <img class="activity-cover" :src="imgUrl+article.cover | ossProcess(690, 320)">
        <div class="activity-info">
          <div class="activity-title">{{article.title}}</div>
          <div v-if="article.summary" class="activity-summary">{{article.summary}}</div>
        </div>
      </div>
    </mt-loadmore>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import {imgUrl,shareIcon} from "../../config";
  import articleService from '../../service/article/ArticleService'
  import shareService from '../../service/share/ShareService'

  export default {
    name: 'ArticleList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        categorySelected:'10',
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        subCategoryId:10,
        articleList:[],
        categoryList:[{name: "百科小知识",id:'10'},{name: "建材选购",id:'15'},{name: "活动总结",id:'14'}],
        allLoaded: false,
        pageNo:1,
        autoFill:false,
        isShowSearch:false,
        showCancel:true,
        keyword:'',
        categoryIdArray:[],
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      if (this.global.categorySelected) {
        this.categorySelected = this.global.categorySelected;
        this.global.categorySelected = '';
      }
      if (this.global.subCategoryId) {
        this.subCategoryId = this.global.subCategoryId;
        this.global.subCategoryId = '';
      }
      this.loadArticleList();
      this.initWechatShare();
    },
    methods: {
      change(categoryId){
        this.categorySelected = categoryId;
        this.subCategoryId = '';
        this.loadArticleList();
      },
      async loadArticleList(onCancel = function(){}){
        if(this.pageNo == 1){
          this.articleList = [];
        }
        let { code, msg, data : {result ,lastPage} } = await articleService.list(this.categoryIdArray,this.subCategoryId,this.keyword,this.pageNo);
        if(code == '0'){
          for(let i = 0; i < result.length;i++){
            if(result[i].title && result[i].title.length>16){
              result[i].title = result[i].title.substring(0,16)+'...'
            }
            if(this.categorySelected != 14 && result[i].summary && result[i].summary.length>22){
              result[i].summary = result[i].summary.substring(0,22)+'...'
            } else if(result[i].summary && result[i].summary.length > 48){
              result[i].summary = result[i].summary.substring(0,46)+'...'
            }
            this.articleList.push(result[i])
          }
          this.allLoaded = lastPage;
          onCancel();
        }else {
          Toast(msg);
        }
      },
      selectCategory(categoryId){
        this.categorySelected = categoryId;
        this.subCategoryId = categoryId;
        this.pageNo = 1;
        this.loadArticleList();
      },
      loadBottom(){
        this.pageNo++;
        this.loadArticleList(()=>{
          this.$refs.loadmore.onBottomLoaded();
        });
      },
      //跳转文章详情
      toArticleDetail(id,title,summary){
        if(!!this.global.isMiniProgrm){
          wx.miniProgram.navigateTo({url: '/pages/article/detail/detail?articleId='+id+"&original=articlelist"});
        }else {
          this.global.categorySelected =this.categorySelected;
          this.global.subCategoryId = this.subCategoryId;
          this.$router.push({name: 'ArticleDetail', query: {articleId:id,title,summary}})
        }
      },
      async initWechatShare(){
        let title = "水木家居商城家居百科";// 分享标题
        let desc = "干货，让家装更简单"; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .article-list-page{
    background: white;
    padding-bottom: 0.5rem;
    font-size: 0.32rem;
    .cms-article{
      width: 6.9rem;
      margin: 0rem auto 0.3rem;
      padding-bottom: 0.3rem;
      .article-cover{
        border-radius: 0.06rem 0.06rem 0rem 0rem;
        width: 6.9rem;
        height: 3.2rem;
      }
      .article-title{
        margin-top: 0.15rem;
        margin-bottom: 0.08rem;
        padding-left: 0.2rem;
        font-size: 0.32rem;
        font-weight: bold;
      }
      .article-summary{
        padding-left: 0.2rem;
        font-size: 0.28rem;
        color: #7f7d7c;
      }
      .activity-cover{
        width: 1.3rem;
        height: 1.3rem;
        margin: 0.2rem;
        border-radius: 0.06rem;
      }
      .activity-info{
        width: 5rem;
        .activity-title{
          margin-top: 0.2rem;
          font-size: 0.32rem;
          font-weight: bold;
        }
        .activity-summary{
          margin-top: 0.1rem;
          font-size: 0.28rem;
          color: #7f7d7c;
        }
      }
    }
    .activity-item{
      display: flex;
    }
    .article-tab-part{
      display: flex;
      line-height: 0.95rem;
      margin-left:0.35rem;
      color: #7f7d7c;
      .top-tab-item{
        padding-right: 0.3rem;
      }
      .tab-selected{
        color: #191818;
        font-size: 0.36rem;
        font-weight:bold;
      }
    }
  }
</style>
